import { Text } from "@chakra-ui/react";

const Subtitle = ({ children, ...rest }) => (
  <Text fontSize="1.4rem" letterSpacing="0.2px" lineHeight="22px" {...rest}>
    {children}
  </Text>
);
export default Subtitle;
